import React from 'react';
import { stages } from '../data/toolkit';
export function SystemSection() {
  return <section className="bg-white py-11 sm:py-14" aria-labelledby="system-title" data-id="element-98" data-mp="3gi9cfu77wxhe">
      <div className="mx-auto w-full max-w-[42rem] px-4 sm:px-6 lg:max-w-5xl" data-id="element-99" data-mp="3biwot78ivmdr">
        <p className="eyebrow text-[0.66rem] font-semibold text-teal sm:text-[0.72rem]" data-id="element-100" data-mp="3bkzokizh8tvo">
          A more organized way to practice
        </p>
        <h2 id="system-title" className="mt-3 font-display text-[1.75rem] leading-[1.15] tracking-tight text-navy sm:text-[2.25rem]" data-id="element-101" data-mp="31l8vmlqkemxp">
          Your clinical knowledge isn’t the problem.
          <span className="mt-1 block text-navy-muted" data-id="element-102" data-mp="2stglkc5gdftn">
            Starting from scratch every session is.
          </span>
        </h2>

        <div className="mt-5 space-y-3.5 lg:max-w-2xl" data-id="element-103" data-mp="2nr7rtdkra9qh">
          <p className="text-[0.98rem] leading-relaxed text-navy-muted" data-id="element-104" data-mp="2it67yqfia6dy">
            You already know how to be an Occupational Therapist. The exhausting
            part is everything surrounding the session: finding the right
            reference, deciding what to focus on, choosing or adapting an
            activity, organizing your notes and preparing what comes next.
          </p>
          <p className="text-[0.98rem] leading-relaxed text-navy-muted" data-id="element-105" data-mp="u1tinea765zq">
            When those resources live across old PDFs, saved articles,
            screenshots, books and personal notes, preparation becomes part of
            the workload. OT Clinical Toolkit™ brings that process into one
            practical structure.
          </p>
        </div>

        <ol className="mt-6 space-y-0 divide-y divide-navy-line border-y border-navy-line lg:grid lg:grid-cols-2 lg:gap-x-10 lg:divide-y-0 lg:border-y-0" data-id="element-106" data-mp="1rmg21p62trqw">
          {stages.map((stage, index) => <li key={stage.label} className="flex items-start gap-3.5 py-3.5 lg:border-t lg:border-navy-line" data-id="element-107" data-mp="1hsfsnb3ri0cd" data-mpi={index}>
              <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-teal-light text-[0.78rem] font-bold text-teal-deep" data-id="element-108" data-mp="6ciseqqh3tzu">
                {index + 1}
              </span>
              <div className="min-w-0" data-id="element-109" data-mp="240crcsvitcix">
                <h3 className="text-[0.85rem] font-bold uppercase tracking-[0.14em] text-navy" data-id="element-110" data-mp="241e73anhen6z">
                  {stage.label}
                </h3>
                <p className="mt-1 text-[0.92rem] leading-relaxed text-navy-muted" data-id="element-111" data-mp="1u86ylgxg2r2o">
                  {stage.description}
                </p>
              </div>
            </li>)}
        </ol>

        <p className="mt-6 border-l-2 border-sand pl-4 text-[1.02rem] font-semibold leading-snug text-navy" data-id="element-112" data-mp="1l7r06lvk6a4o">
          Less time rebuilding the process.
          <span className="block font-normal text-navy-muted" data-id="element-113" data-mp="1bacmgu10rzg2">
            More time actually using it.
          </span>
        </p>
      </div>
    </section>;
}